import React, { useState, useEffect, useRef } from 'react';
import { billing, clients, one, two, oneright, twoleft, manimg, fiirst, second, third, fourth, accounts, dental, consulting, emr, finacess, severices, flatlayImg, doctorImg, workright, arrowbg, trends, risks, business, pay, paln, cost, external1 } from '../../../assets/images';
import { FiArrowDownRight } from 'react-icons/fi';
import { Accordion, Col, Container, Row, Modal } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { getContactApiUrl } from '../../../config/api';
import { Link } from 'react-router-dom';
import PopularArticles from './PopularArticles';
const ChargeEntryAudit = () => {
  const sectionRefs = useRef([]);
  const [animatedSections, setAnimatedSections] = useState(new Set());
  const [hasAnimated, setHasAnimated] = useState(new Set());

  // Event tracking function
  const trackEvent = (action, category, label, location) => {
    if (window.gtag) {
      window.gtag('event', action, {
        event_category: category,
        event_label: label,
        custom_parameter_1: location
      });
    }
  };

  // Event handlers
  const handleServiceClick = (serviceName) => {
    trackEvent('click', 'Charge Entry Audit Services', serviceName, 'services_section');
  };

  const handleCTAClick = (location) => {
    trackEvent('click', 'Charge Entry Audit CTA', 'Lets Connect', location);
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const index = entry.target.dataset.sectionIndex;
          if (index) {
            const sectionIndex = parseInt(index);
            if (entry.isIntersecting && !hasAnimated.has(sectionIndex)) {
              setAnimatedSections(prev => new Set([...prev, sectionIndex]));
              setHasAnimated(prev => new Set([...prev, sectionIndex]));
            }
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    sectionRefs.current.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => {
      observer.disconnect();
    };
  }, []);
  const [showModal, setShowModal] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleClose = () => {
    setShowModal(false);
    setIsSubmitted(false);
  };
  const handleShow = () => setShowModal(true);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const onSubmit = async (data) => {
    setIsSubmitting(true);
    try {
      const response = await axios.post(getContactApiUrl(), {
        fullName: data.fullName,
        email: data.email,
        subject: data.subject,
        message: data.message,
      });
      if (response.data.success) {
        setIsSubmitted(true);
        reset();
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };
  const [activeKey2, setActiveKey2] = useState("0");
  const toggleKey2 = (key) => {
    setActiveKey2(activeKey2 === key ? null : key);
  };
  const services = [
    {
      icon: fiirst,
      alt: "Mobile App Development",
      title: "Accurate Data Capture ",
      description:
        "Every patient detail and service code is entered with precision to eliminate errors and ensure clean claim submissions.",
    },
    {
      icon: second,
      alt: "Software Development",
      title: "Coding & Compliance Validation",
      description:
        "Our team reviews charges against coding guidelines and payer rules, minimizing compliance risks and underpayments.",
    },
    {
      icon: third,
      alt: "Digital Transformation",
      title: "Error Detection & Prevention",
      description:
        "Through detailed audits, we identify discrepancies before submission reducing denials and speeding up reimbursements. ",
    },

    {
      icon: fourth,
      alt: "IT Consulting",
      title: "Revenue Protection ",
      description:
        "By ensuring complete, accurate charge entry, we help practices capture their full revenue potential and strengthen financial performance. ",
    },
  ];
  const familyMedicineServices = [
    {
      title: "Accurate Data Capture ",
      description:
        "Ensure every charge is entered with precision, minimizing missing or incorrect details that could delay payments. ",
      icon: accounts, // Replace with actual icon path
      alt: "Accounts Receivable Icon"
    },
    {
      title: "Compliance-Driven Audits ",
      description:
        "Stay ahead of payer rules with thorough audits that catch coding or modifier errors before claim submission. ",
      icon: dental,
      alt: "Collections & Denial Icon"
    },
    {
      title: "Fewer Claim Rejections ",
      description:
        "Proactive charge audits significantly reduce denial rates by quickly addressing discrepancies early in the process. ",
      icon: consulting,
      alt: "Consulting Icon"
    },
    {
      title: "Optimized Reimbursements ",
      description:
        "Accurate and thoroughly validated charges maximize collections and strengthen your overall revenue cycle.",
      icon: emr,
      alt: "EHR Integration Icon"
    },
    {
      title: "Operational Efficiency ",
      description:
        "Streamlined entry and audit processes free up valuable staff time while significantly improving billing accuracy.",
      icon: finacess,
      alt: "Financial Analysis Icon"
    },
    {
      title: "Actionable Reporting ",
      description:
        "Detailed audit insights highlight recurring issues, helping practices continuously improve billing performance. ",
      icon: severices,
      alt: "Medical Billing Icon"
    }
  ];
  return (
    <>
      <style>{`
        @media (min-width: 768px) {
        
          .animate-section[data-section-index="1"] {
            opacity: 0;
            transform: translateX(-40px) rotateY(5deg);
            transition: all 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.2s;
          }
          .animate-section[data-section-index="1"].visible {
            opacity: 1;
            transform: translateX(0) rotateY(0deg);
          }
          .animate-section[data-section-index="2"] {
            opacity: 0;
            transform: translateY(60px) scale(0.9);
            transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.3s;
          }
          .animate-section[data-section-index="2"].visible {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
          .animate-section[data-section-index="3"] {
            opacity: 0;
            transform: translateY(55px) scale(0.96);
            transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.5s;
          }
          .animate-section[data-section-index="3"].visible {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
          .animate-section[data-section-index="4"] {
            opacity: 0;
            transform: translateY(55px) scale(0.96);
            transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.5s;
          }
          .animate-section[data-section-index="4"].visible {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
          .animate-section[data-section-index="5"] {
            opacity: 0;
            transform: translateX(35px) rotateY(-3deg);
            transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.6s;
          }
          .animate-section[data-section-index="5"].visible {
            opacity: 1;
            transform: translateX(0) rotateY(0deg);
          }
          .animate-section[data-section-index="6"] {
            opacity: 0;
            transform: translateY(45px) scale(0.97);
            transition: all 0.5s ease-out 0.7s;
          }
          .animate-section[data-section-index="6"].visible {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
          .animate-section[data-section-index="7"] {
            opacity: 0;
            transform: translateY(40px) scale(0.98);
            transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.8s;
          }
          .animate-section[data-section-index="7"].visible {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
          .animate-section[data-section-index="8"] {
            opacity: 0;
            transform: translateY(40px) scale(0.98);
            transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.9s;
          }
          .animate-section[data-section-index="8"].visible {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }
        @media (max-width: 767px) {
         
          .animate-section[data-section-index="1"] {
            opacity: 0;
            transform: translateY(20px);
            transition: all 0.6s ease 0.1s;
          }
          .animate-section[data-section-index="1"].visible {
            opacity: 1;
            transform: translateY(0);
          }
          .animate-section[data-section-index="2"] {
            opacity: 0;
            transform: translateY(20px);
            transition: all 0.6s ease 0.2s;
          }
          .animate-section[data-section-index="2"].visible {
            opacity: 1;
            transform: translateY(0);
          }
          .animate-section[data-section-index="3"] {
            opacity: 0;
            transform: translateY(20px);
            transition: all 0.6s ease 0.3s;
          }
          .animate-section[data-section-index="3"].visible {
            opacity: 1;
            transform: translateY(0);
          }
          .animate-section[data-section-index="4"] {
           opacity: 0;
            transform: translateY(20px);
            transition: all 0.6s ease 0.4s;
          }
          .animate-section[data-section-index="4"].visible {
            opacity: 1;
            transform: translateY(0);
          }
          .animate-section[data-section-index="5"] {
            opacity: 0;
            transform: translateY(20px);
            transition: all 0.6s ease 0.5s;
          }
          .animate-section[data-section-index="5"].visible {
            opacity: 1;
            transform: translateY(0);
          }
          .animate-section[data-section-index="6"] {
            opacity: 0;
            transform: translateY(20px);
            transition: all 0.6s ease 0.6s;
          }
          .animate-section[data-section-index="6"].visible {
            opacity: 1;
            transform: translateY(0);
          }
          .animate-section[data-section-index="7"] {
            opacity: 0;
            transform: translateY(20px);
            transition: all 0.6s ease 0.7s;
          }
          .animate-section[data-section-index="7"].visible {
            opacity: 1;
            transform: translateY(0);
          }
          .animate-section[data-section-index="8"] {
            opacity: 0;
            transform: translateY(20px);
            transition: all 0.6s ease 0.8s;
          }
          .animate-section[data-section-index="8"].visible {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .btn {
          transition: all 0.3s ease;
          transform: translateY(0);
        }
        .btn:hover {
          transform: translateY(-3px);
          box-shadow: 0 10px 30px rgba(226, 114, 57, 0.4);
        }
        .services-hover-effect {
          transition: all 0.3s ease;
        }
        .services-hover-effect:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 35px rgba(0,0,0,0.1);
        }
      `}</style>
      <section className="hero-section text-center">
        <div
          className={`about_bg d-md-flex d-none align-items-center justify-content-center add_extra_width animate-section ${animatedSections.has(0) ? 'visible' : ''}`}
          ref={el => sectionRefs.current[0] = el}
          data-section-index="0"
        >

          <div className="row mx-auto mt-5 pt-5">
            <div className="col-12 text-center ">
              <h1 className="about_font text-white fw-bold" >
                Charge Entry & Audit Services:<br /> Accuracy That Drives Revenue Growth
              </h1>
              <p className='mb-0 text-white add_para_font fw-medium'>
                We ensure accurate charge entry and compliance audits to eliminate errors, prevent
                <br /> underpayments, and boost claim acceptance. Our solutions strengthen coding validation,<br />
                protect revenue, and accelerate reimbursements.
              </p>
            </div>
            {/* <div className='col-12 d-flex align-items-center justify-content-center mt-5'>
            <button
              className="btn"
              onClick={handleShow} type="button"
              style={{
                background: "linear-gradient(to right, #F37016 0%, #B1510F 100%)",
                color: "white",
                borderRadius: "12px",
                padding: "12px 40px",
                border: "none",
                fontWeight: "500",
                fontSize: "16px",
              }}
            >
              Let’s Connect                           </button>
          </div> */}
            <div className='col-12 d-flex align-items-center justify-content-center mt-md-4 mt-3'>
              <button
                className="btn add_padding_font"
                onClick={handleShow} type="button"
                style={{
                  background: "linear-gradient(to right, #F37016 0%, #B1510F 100%)",
                  color: "white",
                  borderRadius: "12px",
                  padding: "12px 40px",
                  border: "none",
                  fontWeight: "500",
                  fontSize: "16px",
                }}
              >
                Let's Connect                           </button>
            </div>
          </div>
        </div>

        <div
          className={` add_ng_mobile_img d-md-none d-block align-items-start mt-5 pt-5 justify-content-center add_extra_width animate-section ${animatedSections.has(0) ? 'visible' : ''}`}
          ref={el => sectionRefs.current[0] = el}
          data-section-index="0"
        >

          <div className="row mx-auto ">
            <div className="col-12 text-center ">
              <h1 className="about_font text-white fw-bold" >
                Charge Entry & Audit Services:<br /> Accuracy That Drives Revenue Growth
              </h1>
              <p className='mb-0 text-white add_para_font fw-medium'>
                We ensure accurate charge entry and compliance audits to eliminate errors, prevent
                <br /> underpayments, and boost claim acceptance. Our solutions strengthen coding validation,<br />
                protect revenue, and accelerate reimbursements.
              </p>
            </div>
            <div className='col-12 d-flex align-items-center justify-content-center mt-md-5 mt-3'>
              <button
                className="btn add_padding_font"
                onClick={handleShow} type="button"
                style={{
                  background: "linear-gradient(to right, #F37016 0%, #B1510F 100%)",
                  color: "white",
                  borderRadius: "12px",
                  padding: "12px 40px",
                  border: "none",
                  fontWeight: "500",
                  fontSize: "16px",
                }}
              >
                Let's Connect                           </button>
            </div>
          </div>
        </div>
      </section>
      {/* <div 
        className={`container add_box_shadow_rounded bg-white animate-section ${animatedSections.has(1) ? 'visible' : ''}`}
        ref={el => sectionRefs.current[1] = el}
        data-section-index="1"
      >
        <div className='row mx-auto py-md-5 py-3'>
          <div className='col-12 add_border_bottom pb-md-4 pb-3 text-start px-0'>
            <h3 className='mb-0 add_driving_font fw-semibold text-center'>
              Charge Entry & Audit <span className='add_grident_font'> Expertise</span>
            </h3>
          </div>
          <div className='col-12'>
            <div className='row'>
              <div className='col-md-3 col-6'>
                <div className='row'>
                  <div className='col-12 pt-4 pb-md-0 pb-0'>
                    <h3 className=' text-md-start text-center add_grident_font add_head_font_year fw-semibold mb-0'>
                      15+
                    </h3>
                    <p className='text-md-start text-center mt-0 add_font_another fw-medium mb-3 mb-md-0'>
                      Years of Experience
                    </p>
                  </div>
                </div>
              </div>
              <div className='col-md-3 col-6'>
                <div className='row'>
                  <div className='col-12 pt-4 pb-md-0 pb-0'>
                    <h3 className=' text-md-start text-center add_grident_font add_head_font_year fw-semibold mb-0'>
                      2000+
                    </h3>
                    <p className='text-md-start text-center mt-0 add_font_another fw-medium mb-md-0 mb-3'>
                      Team Members
                    </p>
                  </div>
                </div>
              </div>
              <div className='col-md-3 col-6'>
                <div className='row'>
                  <div className='col-12 pt-md-4 pt-0 pb-md-0 pb-0'>
                    <h3 className=' text-md-start text-center add_grident_font add_head_font_year fw-semibold mb-0'>
                      $2.7B+
                    </h3>
                    <p className='text-md-start text-center mt-0 add_font_another fw-medium mb-0'>
                      In Payments
                    </p>
                  </div>
                </div>
              </div>
              <div className='col-md-3 col-6'>
                <div className='row'>
                  <div className='col-12 pt-md-4 pt-0 pb-md-0 pb-0'>
                    <h3 className=' text-md-start text-center add_grident_font add_head_font_year fw-semibold mb-0'>
                      $20B+
                    </h3>
                    <p className='text-md-start text-center mt-0 add_font_another fw-medium mb-0'>
                      In Charges
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <div
        className={`boost_main_clie position-relative animate-section ${animatedSections.has(2) ? 'visible' : ''}`}
        ref={el => sectionRefs.current[2] = el}
        data-section-index="2">
        <div className='container pt-lg-4'>
          <div className='row py-md-5 py-4 mx-auto'>
            <div className='col-12 d-flex align-items-center text-center pe-0 justify-content-center'>
              <h2 className='mb-0 d-flex align-items-center justify-content-center add_font_head fw-semibold'>
                Charge Entry & Audit Excellence: Precision and Compliance
              </h2>
            </div>
            <div className='col-12 mt-md-5 mt-0'>
              <div className='row mt-md-4 mt-0'>
                <div className='col-lg-6 mt-4'>
                  <div className='row'>
                    <div className="col-md-2 col-12 text-center text-md-start mt-2 pe-md-0 pe-2 mb-2 mb-md-0">
                      <img src={one} alt='certified provider credentialing specialist' style={{ width: "3rem", height: "3rem", objectFit: "contain" }} />
                    </div>
                    <div className='col-lg-10 ps-0'>
                      <div className='row'>
                        <div className='col-12 d-flex align-items-start text-md-start text-center pe-0 justify-content-md-start justify-content-center mb-2 mb-md-0'>
                          <h3 className='mb-0 d-flex align-items-center justify-content-start fw-semibold add_subheading_font_text'>
                            Accurate Data Capture Prevents Revenue Loss                                     </h3>
                        </div>
                        <div className='col-12 d-flex align-items-start justify-content-md-start justify-content-center mt-md-3 mb-md-3'>
                          <p className='mb-0 d-flex align-items-start justify-content-md-start justify-content-center text-md-start text-center add_small_font_text'>
                            Every patient detail and service code is entered with precision to eliminate errors and ensure clean claim submissions. Our meticulous approach prevents missed charges and reduces the risk of underpayments.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-lg-6 mt-3 mt-md-0'>
                  <div className='row mx-auto'>
                    <div className='col-12'>
                      <img src={oneright} alt='certified provider credentialing specialist' className='twogroup_imgs' />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-12 mt-md-5 mt-3'>
              <div className='row'>
                <div className='col-lg-6 d-md-block d-none'>
                  <div className='row mx-auto'>
                    <div className='col-12'>
                      <img src={twoleft} alt='Provider Enrollment' className='twogroup_imgs' />
                    </div>
                  </div>
                </div>
                <div className='col-lg-6 mt-md-4 mt-0'>
                  <div className='row'>
                    <div className="col-md-2 col-12 text-center text-md-start mt-2 pe-md-0 pe-2 mb-2 mb-md-0">
                      <img src={two} alt='Provider Enrollment' style={{ width: "3rem", height: "3rem", objectFit: "contain" }} />
                    </div>
                    <div className='col-lg-10 ps-0'>
                      <div className='row'>
                        <div className='col-12 d-flex align-items-start text-md-start text-center pe-0 justify-content-md-start justify-content-center mb-2 mb-md-0'>
                          <h3 className='mb-0 d-flex align-items-center justify-content-md-start justify-content-center fw-semibold add_subheading_font_text'>
                            Proactive Audits Strengthen Revenue Integrity                                     </h3>
                        </div>
                        <div className='col-12 d-flex align-items-start justify-content-md-start justify-content-center mt-md-3 mb-md-3'>
                          <p className='mb-0 d-flex align-items-start justify-content-md-start justify-content-center text-md-start text-center add_small_font_text'>
                            Through detailed audits, we identify discrepancies before submission, reducing denials and speeding up reimbursements. Our compliance-focused approach protects your practice from costly errors.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='boost_main_client boost_main_client_two position-absolute'>
          <img src={clients} alt='' />
        </div>
      </div>

      <div
        className={`section_data position-relative animate-section pb-md-4 pb-0 ${animatedSections.has(3) ? 'visible' : ''}`}
        ref={el => sectionRefs.current[3] = el}
        data-section-index="3"
      >
        <div class="boost_main_client boost_main_client_two_sets position-absolute"><img src={clients} alt="" /></div>
        <div className="container px-0 px-md-0 pb-md-5 pt-md-4 pb-3 pt-0">
          <div className="row justify-content-center mx-auto">

            <div className='col-12 d-flex align-items-center justify-content-center'>
              <h2 className='mb-0 d-flex align-items-center justify-content-center add_font_head fw-semibold text-center'>
                Boosting Compliance and Revenue
              </h2>
            </div>

            <div className="col-12 mt-md-4 mt-2 px-1 px-md-0">
              <div className="row mx-auto">
                {services.map((service, index) => (
                  <div
                    key={index}
                    className="col-6 col-sm-12 col-md-3 position-relative mb-md-0 mb-0 p-2"
                  >
                    <div className="row h-100 mx-auto">
                      <div
                        className="col py-md-5 py-3 px-md-2 px-0 border services-hover-effect"
                        style={{ borderRadius: "21px", cursor: 'pointer' }}
                        onClick={() => handleServiceClick(service.title)}
                      >
                        <div className="row mx-auto">
                          <div className="col-12 d-md-flex d-block align-items-center justify-content-md-start justify-content-center mb-md-3 mb-0 text-start text-md-start">
                            <img
                              src={service.icon}
                              alt={service.alt}
                              loading="lazy"
                              className="mb-2 mb-md-0"
                              style={{
                                width: "45px",
                                height: "45px",
                                objectFit: "contain",
                              }}
                            />

                          </div>
                          <div className='col-12 text-start mb-md-3 mb-2 '>
                            <h3 className="add_font_another mb-0 fw-semibold text-start">
                              {service.title}
                            </h3>
                          </div>
                          <div className="col-12 text-start">
                            <p className="mb-0 add_font_card_para_data">
                              {service.description}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <img
                      src="/static/media/wire.33ad6b5bff2f03eb7311.webp"
                      alt=""
                      className="add_position_card_img position-absolute"
                      loading="lazy"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <section
        className="py-lg-5 pb-0 px-0 px-md-5 add_bg_image_test d-md-block d-none">
      </section>
      <Container
        className={`animate-section ${animatedSections.has(4) ? 'visible' : ''}`}
        ref={el => sectionRefs.current[4] = el}
        data-section-index="4"
      >
        <Row className="align-items-center mb-md-5 mb-4 pb-md-4 pb-0">

          <Col lg={5} className=" pe-lg-6 bg-white border px-3 py-md-4 py-0 remove_margintop order-1 order-md-0 " style={{ borderRadius: "12px", marginTop: "-7rem" }}>
            <div class="accordion" id="accordionExample">
              <div class="accordion-item border-bottom border-0">
                <h3 class="accordion-header" id="headingOne">
                  <button class="accordion-button add_custom_font" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    Streamlined Data Entry
                    <span class="accordion-icon ms-auto">
                      <svg class="icon-open" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#F37016" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z" />
                      </svg>
                      <svg class="icon-close" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#F37016" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                      </svg>
                    </span>
                  </button>
                </h3>
                <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                  <div class="accordion-body add_custom_font_para px-0">
                    Our team captures patient and service details with accuracy, minimizing manual errors and missing data. This ensures claims are complete and ready for smooth processing.                  </div>
                </div>
              </div>
              <div class="accordion-item border-bottom border-0">
                <h3 class="accordion-header" id="headingTwo">
                  <button class="accordion-button collapsed add_custom_font" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                    Smart Audit Reviews
                    <span class="accordion-icon ms-auto">
                      <svg class="icon-open" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#F37016" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z" />
                      </svg>
                      <svg class="icon-close" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#F37016" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                      </svg>
                    </span>
                  </button>
                </h3>
                <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                  <div class="accordion-body add_custom_font_para px-0">
                    Each charge goes through proactive checks for coding accuracy, modifiers, and payer rules, helping identify issues early and maintain compliance.                  </div>
                </div>
              </div>
              <div class="accordion-item border-bottom border-0">
                <h3 class="accordion-header" id="headingThree">
                  <button class="accordion-button collapsed add_custom_font" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                    Denial Prevention
                    <span class="accordion-icon ms-auto">
                      <svg class="icon-open" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#F37016" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z" />
                      </svg>
                      <svg class="icon-close" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#F37016" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                      </svg>
                    </span>
                  </button>
                </h3>
                <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                  <div class="accordion-body add_custom_font_para px-0">
                    By detecting discrepancies before submission, we reduce claim rework and prevent costly denials, improving first-pass acceptance rates.                  </div>
                </div>
              </div>
              <div class="accordion-item border-0">
                <h3 class="accordion-header" id="headingFour">
                  <button class="accordion-button collapsed add_custom_font" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                    Financial Confidence
                    <span class="accordion-icon ms-auto">
                      <svg class="icon-open" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#F37016" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z" />
                      </svg>
                      <svg class="icon-close" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#F37016" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                      </svg>
                    </span>
                  </button>
                </h3>
                <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionExample">
                  <div class="accordion-body add_custom_font_para px-0">
                    With accurate entry and thorough audits, your billing stays compliant, transparent, and optimized for maximum reimbursement.                  </div>
                </div>
              </div>

            </div>

          </Col>
          <Col lg={7} className="d-flex gap-md-3 gap-0 justify-content-center flex-wrap ps-lg-5 my-md-5 mt-0 mb-0 order-0 order-md-1 ">

            <div className="col-lg-12 m-0 col-12  mt-0  text-lg-start text-center flex-column d-flex justify-content-center">
              <h2 className='text-black contact-text  m-0 mt-lg-0 mt-0'>
                Enhancing Accuracy, Preventing Denials with Charge Entry & Audit
              </h2>
              <p className=' any-para mt-3 mt-lg-4 mb-md-0 mb-3'>Our charge entry and audit services go beyond basic data entry, we focus on accuracy, compliance, and revenue integrity. By combining technology with expert review, we help practices avoid costly errors, speed up claim approvals, and ensure every service is billed correctly.</p>
            </div>
            <div className='col-12 d-flex align-items-center justify-content-md-start justify-content-center mt-md-2 mt-0 mb-3 mb-md-0'>
              <button
                className="btn add_padding_font"
                onClick={handleShow} type="button"
                style={{
                  background: "linear-gradient(to right, #F37016 0%, #B1510F 100%)",
                  color: "white",
                  borderRadius: "12px",
                  padding: "12px 40px",
                  border: "none",
                  fontWeight: "500",
                  fontSize: "16px",
                }}
              >
                Let’s Connect                           </button>
            </div>
          </Col>
        </Row>
      </Container>
      <div
        className={`container py-lg-5 py-4 px-2 px-md-5 change_radius mx-auto d-flex align-items-center justify-content-center my-md-5 my-0 position-relative animate-section ${animatedSections.has(5) ? 'visible' : ''}`}
        ref={el => sectionRefs.current[5] = el}
        data-section-index="5"
        style={{ background: "#2A3040", borderBottom: "15px solid #9CB5FF" }}
      >
        {/* <img src={mentalhealth} alt='' className='position-absolute boost_main_client_mental' /> */}
        <div className='row mx-auto'>
          <div className='col-12 d-flex align-items-center text-center pe-0 justify-content-center mb-md-5 mb-3'>
            <h2 className='mb-0 d-md-block align-items-center justify-content-center add_font_head fw-semibold text-white d-none '>
              From Accuracy to Reimbursement: Smarter Charge <br />Entry & Audit
            </h2>
            <h2 className='mb-0 d-block align-items-center justify-content-center add_font_head fw-semibold text-white d-md-none mt-0 pt-0'>
              From Accuracy to Reimbursement: Smarter Charge Entry & Audit
            </h2>
          </div>
          <div className='col-12 '>
            <div className='row border-bottom-gray pb-md-4 pb-2 mx-auto'>
              <div className='col-md-6 col-5 ps-0'>
                <h3 class="mb-0 d-flex align-items-center justify-content-start fw-semibold add_subheading_font_text text-white text-start"><FiArrowDownRight className='pe-2 me-2 mb-3 d-md-block d-none' />
                  End-to-End Charge Entry                                    </h3>                      </div>
              <div className='col-md-6 col-7 pe-0'>
                <p class="mb-0 d-flex align-items-start justify-content-start text-start text-white add_small_font_text">
                  Accurate charge entry is the foundation of a healthy revenue cycle. Our team captures patient demographics, provider details, and billing codes with precision to ensure every service is accounted for. This reduces missed charges, improves claim accuracy, and speeds up reimbursements.
                </p>
              </div>
            </div>
          </div>
          <div className='col-12 '>
            <div className='row border-bottom-gray py-md-4 py-2 mx-auto'>
              <div className='col-md-6 col-5 ps-0'>
                <h3 class="mb-0 d-flex align-items-center justify-content-start fw-semibold add_subheading_font_text text-white text-start"><FiArrowDownRight className='pe-2 me-2 mb-3 d-md-block d-none' />
                  Compliance & Coding Review                                    </h3>                      </div>
              <div className='col-md-6 col-7 pe-0'>
                <p class="mb-0 d-flex align-items-start justify-content-start text-start text-white add_small_font_text">We conduct thorough audits to validate CPT, ICD-10, and modifier usage against payer requirements and industry standards. This not only helps avoid compliance risks but also prevents underpayments and ensures your practice receives fair compensation. </p>
              </div>
            </div>
          </div>
          <div className='col-12 '>
            <div className='row border-bottom-gray py-md-4 py-2 mx-auto'>
              <div className='col-md-6 col-5 ps-0'>
                <h3 class="mb-0 d-flex align-items-center justify-content-start fw-semibold add_subheading_font_text text-white text-start"><FiArrowDownRight className='pe-2 me-2 mb-3 d-md-block d-none' />
                  Error Detection & Denial Control                                   </h3>                      </div>
              <div className='col-md-6 col-7 pe-0'>
                <p class="mb-0 d-flex align-items-start justify-content-start text-start text-white add_small_font_text">Before claims are submitted, our experts perform detailed reviews to identify inconsistencies, missing information, or documentation gaps. By resolving these issues in advance, we minimize denials, reduce costly rework, and improve first-pass acceptance rates. </p>
              </div>
            </div>
          </div>
          <div className='col-12 '>
            <div className='row pt-md-4 pt-2 mx-auto'>
              <div className='col-md-6 col-5 ps-0'>
                <h3 class="mb-0 d-flex align-items-center justify-content-start fw-semibold add_subheading_font_text text-white text-start"><FiArrowDownRight className='pe-2 me-2 mb-3 d-md-block d-none' />
                  Revenue Assurance & Insights                                     </h3>                      </div>
              <div className='col-md-6 col-7 pe-0'>
                <p class="mb-0 d-flex align-items-start justify-content-start text-start text-white add_small_font_text">Our audits go beyond error correction, we provide actionable insights through reporting and trend analysis. Practices gain visibility into recurring issues, revenue leakage points, and opportunities for process improvement, building long-term financial confidence. </p>
              </div>
            </div>
          </div>

        </div>
      </div>

      <section
        className={`py-lg-5 my-4 mt-md-4 mb-md-0 pb-0 px-0 px-md-5 add_border_radius_second animate-section ${animatedSections.has(6) ? 'visible' : ''}`}
        ref={el => sectionRefs.current[6] = el}
        data-section-index="6"
        style={{ background: "#EFF3FF" }}
      >
        <div className="container py-4">
          <div className="row mb-4 mx-auto">
            <div class="col-12 d-flex align-items-center justify-content-center"><h2 class="mb-0 d-flex align-items-center justify-content-center add_font_head fw-semibold text-center">
              Key Benefits for Your Practice  </h2></div>
          </div>

          <div className="row g-md-2 g-2">
            {/* 1. Save Cost */}
            <div className="col-md-6 px-2 py-2 mt-0">
              <div className="bg-white p-3 rounded shadow-sm d-flex h-100 align-items-start gap-3 services-hover-effect" style={{ transition: 'all 0.3s ease', cursor: 'pointer' }} onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)'; }} onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = ''; }}>

                <div className="flex-shrink-0">
                  <img
                    src={cost}
                    alt="Save cost"
                    className="rounded mt-1"
                    style={{
                      width: '48px',
                      height: '48px',
                      objectFit: 'contain',
                      padding: '10px',
                      backgroundColor: 'rgb(50, 62, 74)',
                    }}
                  />
                </div>
                <div className="text-start">
                  <h3 className="fw-semibold font_color add_font_heading_benfits mb-2">Save Time & Resources </h3>
                  <p className="add_font_card_para font_color mb-0 mt-0">
                    Automated charge entry and audit workflows reduce manual work, allowing your staff to focus more on patient care.
                  </p>
                </div>
              </div>
            </div>

            {/* 2. Professional Plan */}
            <div className="col-md-6 px-2 py-2 mt-0">
              <div className="bg-white p-3 rounded shadow-sm d-flex h-100 align-items-start gap-3 services-hover-effect" style={{ transition: 'all 0.3s ease', cursor: 'pointer' }} onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)'; }} onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = ''; }}>

                <div className="flex-shrink-0">
                  <img
                    src={paln}
                    alt="Professional Plan"
                    className="rounded mt-1"
                    style={{
                      width: '48px',
                      height: '48px',
                      objectFit: 'contain',
                      padding: '10px',
                      backgroundColor: 'rgb(50, 62, 74)',
                    }}
                  />
                </div>
                <div className="text-start">
                  <h3 className="fw-semibold font_color add_font_heading_benfits mb-2">Improve Claim Acceptance </h3>
                  <p className="add_font_card_para font_color mb-0 mt-0">
                    Thorough auditing ensures accurate coding and compliance with payer rules, reducing rejections and speeding reimbursements.
                  </p>
                </div>
              </div>
            </div>

            {/* 3. Pay-per-Use */}
            <div className="col-md-6 px-2 py-2 mt-0">
              <div className="bg-white p-3 rounded shadow-sm d-flex h-100 align-items-start gap-3 services-hover-effect" style={{ transition: 'all 0.3s ease', cursor: 'pointer' }} onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)'; }} onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = ''; }}>

                <div className="flex-shrink-0">
                  <img
                    src={pay}
                    alt="Pay-per-Use"
                    className="rounded mt-1"
                    style={{
                      width: '48px',
                      height: '48px',
                      objectFit: 'contain',
                      padding: '10px',
                      backgroundColor: 'rgb(50, 62, 74)',
                    }}
                  />
                </div>
                <div className="text-start">
                  <h3 className="fw-semibold font_color add_font_heading_benfits mb-2">Minimize Financial Risks </h3>
                  <p className="add_font_card_para font_color mb-0 mt-0">
                    By identifying discrepancies before submission, audits prevent costly errors that could delay or reduce payments.
                  </p>
                </div>
              </div>
            </div>

            {/* 4. Boost Performance */}
            <div className="col-md-6 px-2 py-2 mt-0">
              <div className="bg-white p-3 rounded shadow-sm d-flex h-100 align-items-start gap-3 services-hover-effect" style={{ transition: 'all 0.3s ease', cursor: 'pointer' }} onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)'; }} onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = ''; }}>

                <div className="flex-shrink-0">
                  <img
                    src={business}
                    alt="Boost Performance"
                    className="rounded mt-1"
                    style={{
                      width: '48px',
                      height: '48px',
                      objectFit: 'contain',
                      padding: '10px',
                      backgroundColor: 'rgb(50, 62, 74)',
                    }}
                  />
                </div>
                <div className="text-start">
                  <h3 className="fw-semibold font_color add_font_heading_benfits mb-2">Boost Revenue Performance </h3>
                  <p className="add_font_card_para font_color mb-0 mt-0">
                    Consistent accuracy in charge entry translates into optimized reimbursements and healthier revenue cycles.
                  </p>
                </div>
              </div>
            </div>

            {/* 5. Reduce Risks */}
            <div className="col-md-6 px-2 py-2 mt-0">
              <div className="bg-white p-3 rounded shadow-sm d-flex h-100 align-items-start gap-3 services-hover-effect" style={{ transition: 'all 0.3s ease', cursor: 'pointer' }} onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)'; }} onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = ''; }}>

                <div className="flex-shrink-0">
                  <img
                    src={risks}
                    alt="Reduce Risks"
                    className="rounded mt-1"
                    style={{
                      width: '48px',
                      height: '48px',
                      objectFit: 'contain',
                      padding: '10px',
                      backgroundColor: 'rgb(50, 62, 74)',
                    }}
                  />
                </div>
                <div className="text-start">
                  <h3 className="fw-semibold font_color add_font_heading_benfits mb-2">Stay Compliant</h3>
                  <p className="add_font_card_para font_color mb-0 mt-0">
                    Regular audits safeguard against regulatory risks, ensuring every claim meets payer and compliance standards.
                  </p>
                </div>
              </div>
            </div>

            {/* 6. Market Insights */}
            <div className="col-md-6 px-2 py-2 mt-0">
              <div className="bg-white p-3 rounded shadow-sm d-flex h-100 align-items-start gap-3 services-hover-effect" style={{ transition: 'all 0.3s ease', cursor: 'pointer' }} onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)'; }} onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = ''; }}>

                <div className="flex-shrink-0">
                  <img
                    src={trends}
                    alt="Market Insights"
                    className="rounded mt-1"
                    style={{
                      width: '48px',
                      height: '48px',
                      objectFit: 'contain',
                      padding: '10px',
                      backgroundColor: 'rgb(50, 62, 74)',
                    }}
                  />
                </div>
                <div className="text-start">
                  <h3 className="fw-semibold font_color add_font_heading_benfits mb-2">Gain Actionable Insights </h3>
                  <p className="add_font_card_para font_color mb-0 mt-0">
                    Detailed audit reports highlight trends, common errors, and opportunities for process improvements.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        className={`pb-md-0 pb-0 px-0 px-md-5 position-relative animate-section ${animatedSections.has(7) ? 'visible' : ''}`}
        ref={el => sectionRefs.current[7] = el}
        data-section-index="7"
      >
        <div className='boost_main_client boost_main_client_two_sets position-absolute'>
          <img src={clients} alt='' />
        </div>
        <div class="boost_main_client boost_main_client_tranform_first_data position-absolute"><img src={clients} alt="" /></div>

        <div className="container px-0 px-md-0 py-md-5 py-0">
          <div className="row justify-content-center mx-auto py-lg-4">


            <div className='col-12 d-flex flex-column align-items-center justify-content-start'>
              <h2 className='mb-0 d-flex align-items-center justify-content-start add_font_head fw-semibold text-center text-md-start '>
                Smart Charge Validation and Audit for Revenue Integrity

              </h2>
              <p className="mb-0 text-dark add_para_font fw-medium text-center text-md-start">
                <a
                  href="https://probillrcm.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "inherit", textDecoration: "none", fontWeight: "bold" }}
                >
                  ProBill RCM
                </a>{" "}
                combines industry expertise, advanced technology, and personalized support to deliver seamless AR solutions
                <br />
                that boost efficiency and accelerate revenue for healthcare providers.
              </p>            </div>
            <div className="col-12 mt-md-4 mt-2 px-1 px-md-0">
              <div className="row mx-auto">
                {familyMedicineServices.map((service, index) => (
                  <div
                    key={index}
                    className="col-6 col-sm-12 col-md-4 position-relative mb-md-0 mb-0 p-2"
                  >
                    <div className="row h-100 mx-auto">
                      <div
                        className="col py-md-4 py-3 px-md-3 px-0 services-hover-effect-data bg-white add_border_bottom_sets"
                        onClick={() => handleServiceClick(service.title)}
                        style={{ cursor: 'pointer' }}
                      >
                        <div className="row mx-auto">
                          <div className="col-12 d-md-flex d-block align-items-center justify-content-md-start justify-content-center mb-md-3 mb-0 text-start text-md-start">
                            <img
                              src={service.icon}
                              alt={service.alt}
                              loading="lazy"
                              className="mb-2 mb-md-0"
                              style={{
                                width: "45px",
                                height: "45px",
                                objectFit: "contain"
                              }}
                            />
                          </div>
                          <div className="col-12 text-start mb-md-3 mb-2">
                            <h3 className="add_top_heading_content mb-0 ms-md-0 ms-0 fw-semibold">
                              {service.title}
                            </h3>
                          </div>
                          <div className="col-12 text-start">
                            <p className="mb-0 add_font_card_para_data">
                              {service.description}
                            </p>
                          </div>
                          {/* <div className="col-12 text-end">
                            <p className="mb-0 add_font_card_para_data d-flex align-items-center justify-content-end add_grident_font fw-bold">
                              Learn More <i className="bi bi-arrow-right-short fs-3 ms-1"></i>
                            </p>
                          </div> */}

                        </div>
                      </div>
                    </div>
                    <img
                      src="/static/media/wire.33ad6b5bff2f03eb7311.webp"
                      alt=""
                      className="add_position_card_img position-absolute"
                      loading="lazy"
                    />
                  </div>
                ))}

              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="add_second_bg_image py-md-4 mb-md-5 mb-4 mt-4 mt-md-0 py-0">
        <div className="container">
          <div className="row align-items-center py-md-5 pt-5 pb-0 mx-auto">
            {/* Left Image */}
            <div className="col-lg-6 mb-4 mb-lg-0 d-flex align-items-center justify-content-center pe-5">
              <img
                src={manimg}
                alt="charge entry services"
                className="Men2 position-relative z-1 rounded"
              />
            </div>

            {/* Right Content */}
            <div className="col-lg-6 box4">
              {/* Section Header */}
              <div class="col-lg-12 m-0 col-12  mt-0  text-lg-start text-center flex-column d-flex justify-content-center">
                <h2 class="text-black contact-text  m-0 mt-lg-0 mt-0" style={{ whiteSpace: "nowrap" }}>
                  Streamlined Charge Entry & Audit </h2>
                <p class=" any-para mt-3 mt-lg-4 mb-0 text-center text-md-start">
                  Avoid revenue leakage and compliance risks with accurate charge entry and thorough audits. Our team validates charges against documentation and coding standards to catch errors before submission, helping practices reduce denials, minimize rework, and accelerate reimbursements while staying fully compliant.                </p>
              </div>
              <div className='col-12 d-flex align-items-center justify-content-md-start justify-content-center mt-md-5 mt-3 mb-4 mb-md-0'>
                <button
                  className="btn add_padding_font"
                  onClick={handleShow} type="button"
                  style={{
                    background: "linear-gradient(to right, #F37016 0%, #B1510F 100%)",
                    color: "white",
                    borderRadius: "12px",
                    padding: "12px 40px",
                    border: "none",
                    fontWeight: "500",
                    fontSize: "16px",
                  }}
                >
                  Let’s Connect                          </button>
              </div>


            </div>
          </div>
        </div>
      </section>

      <div
        className={`container about_bg_blue mb-md-5 mb-4 mt-4 mt-md-0 animate-section visible py-4 py-md-4 animate-section ${animatedSections.has(8) ? 'visible' : ''}`}
        ref={el => sectionRefs.current[8] = el}
        data-section-index="8"
        style={{ borderRadius: "36px" }}
      >
        <div className="row mx-auto mt-0 mt-lg-0 py-md-5 py-0">
          <div className="col-lg-9 mx-auto m-0 col-12  mt-md-0 mt-0 pb-3 text-lg-center flex-column d-flex justify-content-center">
            <h2 className='text-white contact-text  m-0 mt-lg-0 mt-0 text-center d-md-block d-none'>
              Strengthen Your Revenue with Accurate Charge <br /> Entry & Proactive Audits
            </h2>
            <h3 className='text-white contact-text  m-0 mt-lg-0 mt-0 text-center d-md-none d-block'>
              Strengthen Your Revenue with Accurate Charge Entry & Proactive Audits
            </h3>
            <p className=' any-para mt-3 mt-lg-4 mb-0 text-center' style={{ color: 'rgba(255, 255, 255, 1)' }}>
              Ensure every claim starts right. Our charge entry specialists meticulously capture and validate charges, aligning them with clinical documentation and payer rules. Proactive audits further safeguard accuracy, reduce denials, and protect against compliance risks. With fewer errors and faster reimbursements, your practice gains both financial stability and peace of mind.
            </p>


          </div>
          <div className='col-12 d-flex align-items-center justify-content-center mt-md-4 mt-3'>
            <button
              className="btn add_padding_font"
              onClick={handleShow} type="button"
              style={{
                background: "linear-gradient(to right, #F37016 0%, #B1510F 100%)",
                color: "white",
                borderRadius: "12px",
                padding: "12px 40px",
                border: "none",
                fontWeight: "500",
                fontSize: "16px",
              }}
            >
              Contact Us                            </button>
          </div>
        </div>
      </div>
      <PopularArticles />

      <Modal show={showModal} onHide={handleClose} centered size='xl'>
        {/* Close Button in Top-Right Corner */}
        <button
          type="button"
          className="btn-close position-absolute"
          style={{
            top: "11px",
            right: "11px",
            zIndex: 1051,
            backgroundColor: "#fff",
            borderRadius: "50%",
            padding: "6px",
            fontSize: "15px",
            //  border:"2px solid black",
          }}
          aria-label="Close"
          onClick={handleClose}
        ></button>

        <Modal.Body className="p-4">
          <div className="container-fluid">
            <div className="row d-flex justify-content-center align-items-center">
              <div className="col-lg-6 d-none d-lg-block">
                <div className="image-container">
                  <img
                    src={external1}
                    alt="Team Working"
                    className="w-100 h-100 diagonal-image"
                  />
                </div>
              </div>
              <div className="col-lg-6 col-md-12 ps-md-4 ps-0">
                {isSubmitted ? (
                  <div className="text-center">
                    <h1 className="hero-text mt-0">
                      Thank <span className="text-orange add_grident_font" style={{ color: "#E9720E" }}>You!</span> <br />
                    </h1>
                    <p>for submitting your information! Our representative will reach out to you shortly.</p>
                  </div>
                ) : (
                  <>
                    <div className="d-flex m-0 modal-heading justify-content-between">
                      <h1>
                        How can we <span style={{ color: "#E27239" }}>help you?</span>
                      </h1>
                      {/* Remove this old close button if not needed */}
                      {/* <button
                                         type="button"
                                         className="btn-close d-lg-none d-block"
                                         onClick={handleClose}
                                         data-bs-dismiss="modal"
                                         aria-label="Close"
                                     ></button> */}
                    </div>
                    <p className="fs-6 m-0 d-lg-none" style={{ color: "#2A3040" }}>
                      Within 24 hours, a representative from our company will contact you.
                    </p>
                    <form onSubmit={handleSubmit(onSubmit)} className="mt-0">
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <label className="form-label fw-medium text-start d-block">Name</label>
                          <input
                            type="text"
                            placeholder="Enter your Full Name"
                            className={`custom_control py-2 form-control ${errors.fullName ? "is-invalid" : ""}`}
                            style={{ border: "1px solid #A4A4A480", height: "48px" }}
                            {...register("fullName", { required: "Full Name is required" })}
                          />
                          {errors.fullName && (
                            <p className="text-danger">{errors.fullName.message}</p>
                          )}
                        </div>

                        <div className="col-md-6 mb-3">
                          <label className="form-label fw-medium text-start d-block">Email</label>
                          <input
                            type="email"
                            placeholder="Enter your Email"
                            className={`custom_control py-2 form-control ${errors.email ? "is-invalid" : ""}`}
                            style={{ border: "1px solid #A4A4A480", height: "48px" }}
                            {...register("email", {
                              required: "Email is required",
                              pattern: {
                                value: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
                                message: "Please enter a valid email address"
                              }
                            })}
                          />
                          {errors.email && (
                            <p className="text-danger">{errors.email.message}</p>
                          )}
                        </div>

                        <div className="col-md-12 mb-3">
                          <label className="form-label fw-medium text-start d-block">Subject</label>
                          <input
                            type="text"
                            placeholder="Enter Subject"
                            className={`custom_control py-2 form-control ${errors.subject ? "is-invalid" : ""}`}
                            style={{ border: "1px solid #A4A4A480", height: "48px" }}
                            {...register("subject", {
                              required: "Subject is required",
                              minLength: {
                                value: 3,
                                message: "Subject should be at least 3 characters long"
                              }
                            })}
                          />
                          {errors.subject && (
                            <p className="text-danger">{errors.subject.message}</p>
                          )}
                        </div>

                        <div className="col-md-12 mb-3">
                          <label className="form-label fw-medium text-start d-block">Message</label>
                          <textarea
                            className={`custom_control py-2 form-control ${errors.message ? "is-invalid" : ""}`}
                            style={{ border: "1px solid #A4A4A480" }}
                            rows="7"
                            placeholder="Brief us on your requirements"
                            {...register("message", {
                              required: "Message is required",
                              minLength: {
                                value: 10,
                                message: "Message should be at least 10 characters long"
                              }
                            })}
                          ></textarea>
                          {errors.message && (
                            <p className="text-danger">{errors.message.message}</p>
                          )}
                        </div>

                        <div className="col-md-12 mt-3">
                          <button
                            type="submit"
                            className="btn col-12"
                            style={{
                              background: "linear-gradient(to right, #F37016 0%, #B1510F 100%)",
                              color: "white",
                              borderRadius: "12px",
                              padding: "12px 24px",
                              border: "none",
                              fontWeight: "500",
                              fontSize: "16px"
                            }}
                            disabled={isSubmitting}
                          >
                            {isSubmitting ? "SENDING..." : "Submit Now"}
                          </button>
                        </div>
                      </div>
                    </form>
                  </>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ChargeEntryAudit;
